import * as React from "react";

function More(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 6" fill="none" {...props}>
      <path
        d="M3.125 0C1.406 0 0 1.35 0 3s1.406 3 3.125 3S6.25 4.65 6.25 3 4.844 0 3.125 0zm18.75 0c-1.719 0-3.125 1.35-3.125 3s1.406 3 3.125 3S25 4.65 25 3s-1.406-3-3.125-3zM12.5 0c-1.719 0-3.125 1.35-3.125 3s1.406 3 3.125 3 3.125-1.35 3.125-3-1.406-3-3.125-3z"
       fill={props.color||"var(--color-blue-500)"}
        fillOpacity={0.6}
      />
    </svg>
  );
}

export default More;
